// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_app__mODAw {
  height: 100%;
  display: flex;
  justify-content: start;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
}

.App_widgets__JTC\\+o {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 20px;
  padding: 10px;
}

.App_version__OHpTu {
  color: #464242;
  font-size: 20px;
  z-index: 0;
}

.App_beta__2-L1q {
  position: absolute;
  bottom: 0;
  width: 100%;
  font-size: 20px;
  z-index: 0;
  background-color: #232323;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  color: #fff;
  align-items: center;
  gap: 20px;
  padding: 12px 22px;
}
.App_beta__2-L1q .App_title__TMAij {
  display: flex;
  padding: 12px 22px;
  justify-content: center;
  align-items: center;
  max-height: 46px;
  background-color: #1890FF;
  border-radius: 30px;
}
.App_beta__2-L1q .App_site__LQJ0W {
  margin-left: auto;
}

.App_errorMessage__dpa\\+f {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 311px;
  background-color: var(--app-bgc);
  z-index: 2;
}
.App_errorMessage__dpa\\+f svg {
  margin-bottom: 60px;
}
.App_errorMessage__dpa\\+f .App_title__TMAij {
  font: var(--font-46-600);
  margin-bottom: 46px;
}
.App_errorMessage__dpa\\+f .App_subtitle__ZA3vN {
  font: var(--font-34);
  width: 700px;
  text-align: center;
  line-height: 46px;
}
.App_errorMessage__dpa\\+f .App_noInternetSubtitle__DzZhP {
  width: 600px;
}`, "",{"version":3,"sources":["webpack://./src/pages/App/App.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AACJ;AAAI;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAER;AAAI;EACI,iBAAA;AAER;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gCAAA;EACA,UAAA;AACJ;AAAI;EACI,mBAAA;AAER;AAAI;EACI,wBAAA;EACA,mBAAA;AAER;AACI;EACI,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AACR;AACI;EACI,YAAA;AACR","sourcesContent":[".app {\n    height: 100%;\n    display: flex;\n    justify-content: start;\n    flex-direction: column;\n    box-sizing: border-box;\n    overflow: auto;\n    position: relative;\n}\n\n.widgets {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    margin-bottom: 20px;\n    padding: 10px;\n}\n\n.version {\n    color: #464242;\n    font-size: 20px;\n    z-index: 0;\n}\n\n.beta {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    font-size: 20px;\n    z-index: 0;\n    background-color: #232323;\n    height: 70px;\n    box-sizing: border-box;\n    display: flex;\n    color: #fff;\n    align-items: center;\n    gap: 20px;\n    padding: 12px 22px;\n    .title {\n        display: flex;\n        padding: 12px 22px;\n        justify-content: center;\n        align-items: center;\n        max-height: 46px;\n        background-color: #1890FF;\n        border-radius: 30px;\n    }\n    .site {\n        margin-left: auto;\n    }\n}\n\n.errorMessage {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 311px;\n    background-color: var(--app-bgc);\n    z-index: 2;\n    svg {\n        margin-bottom: 60px;\n    }\n    .title {\n        font: var(--font-46-600);\n        margin-bottom: 46px;\n    }\n\n    .subtitle {\n        font: var(--font-34);\n        width: 700px;\n        text-align: center;\n        line-height: 46px;\n    }\n    .noInternetSubtitle {\n        width: 600px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `App_app__mODAw`,
	"widgets": `App_widgets__JTC+o`,
	"version": `App_version__OHpTu`,
	"beta": `App_beta__2-L1q`,
	"title": `App_title__TMAij`,
	"site": `App_site__LQJ0W`,
	"errorMessage": `App_errorMessage__dpa+f`,
	"subtitle": `App_subtitle__ZA3vN`,
	"noInternetSubtitle": `App_noInternetSubtitle__DzZhP`
};
export default ___CSS_LOADER_EXPORT___;
